// import React, { useState, useEffect } from "react";
export default function Diplome() {
  return (
    <img
      className="svg_lifeline"
      src="/svg/diplome.svg"
      alt=""
    />
  );
}
